import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { toaster } from '../atoms/shared';

const useShowToaster = () => {
  const [messages, setMessages] = useRecoilState(toaster);

  const removeById = useCallback((id) => setMessages((current) => current.filter((message) => message.id !== id)), [
    setMessages
  ]);

  return { data: messages, removeById };
};

export default useShowToaster;
